import styled, { css } from 'styled-components';
import { Flex, isMobileStyleMixin, CloseButton, Text } from '@amzn/storm-ui';
import { P as PageHeaderWrapper } from './PageHeader.styles-DKUNRW-4.js';

const FocusPageHeaderWrapper = /*#__PURE__*/styled(PageHeaderWrapper).attrs({
  justifyContent: 'space-between',
  direction: 'row',
  gap: 'none'
}).withConfig({
  componentId: "sc-storm-ui-40026394__sc-99642-0"
})([""]);
const FocusCloseButton = /*#__PURE__*/styled(CloseButton).withConfig({
  componentId: "sc-storm-ui-40026394__sc-99642-1"
})(["margin-inline-end:", ";"], ({
  theme
}) => theme.spacing[150]);
const FocusTitle = /*#__PURE__*/styled(Flex).withConfig({
  componentId: "sc-storm-ui-40026394__sc-99642-2"
})(["align-items:center;min-height:32px;", " margin-inline-end:", ";"], isMobileStyleMixin(css(["min-height:44px;"])), ({
  theme
}) => theme.spacing[150]);
const HelpMeHereIconButtonWrapper = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-storm-ui-40026394__sc-99642-3"
})(["position:relative;"]);
const HelpMeHereNotificationsCounter = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-40026394__sc-99642-4"
})(["position:absolute;top:0;right:-4px;display:inline-flex;justify-content:center;align-items:center;border-radius:50%;font-size:10px;line-height:10px;height:15px;width:15px;background-color:", ";color:", ";"], ({
  theme
}) => theme.color.red[700], ({
  theme
}) => theme.color.gray[0]);

export { FocusPageHeaderWrapper as F, HelpMeHereIconButtonWrapper as H, FocusTitle as a, FocusCloseButton as b, HelpMeHereNotificationsCounter as c };
//# sourceMappingURL=FocusPageHeader.styles-DygDK2r5.js.map
